export function useSearchFiltersFundingProgramAbbr(searchFilters?: {
  fundingPrograms?: string[] | string | null;
}) {
  const fundingPrograms =
    typeof searchFilters?.fundingPrograms === "string"
      ? searchFilters?.fundingPrograms.split(",")
      : searchFilters?.fundingPrograms;
  if (!!fundingPrograms?.[0]) {
    return fundingPrograms?.[0];
  }

  return null;
}
